module.exports = __webpack_public_path__ + "media/categories/26v-8026af9c.svg";